import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, FolderOpen, Users, BarChart3, Settings, Laptop, Calendar, GraduationCap, Award, ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const iconMap = {
  FileText,
  FolderOpen,
  Users,
  BarChart3,
  Settings,
  Laptop,
  Calendar,
  GraduationCap,
  Award
};

const Services = () => {
  const { t, services, isRTL } = useLanguage();

  const serviceSlugMap = [
    "claims-consulting",
    "medical-records-consulting",
    "insured-patients",
    "data-analysis-consulting",
    "admin-consulting",
    "technical-consulting",
    "events-management",
    "cme-and-medical-staff-training",
    "elite-services"
  ];

  return (
    <div>
      {/* Hero Section */}
      <div 
        className="relative h-80 bg-cover bg-center"
        style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1920&q=80)' }}
      >
        <div className="absolute inset-0 bg-slate-900 bg-opacity-60 flex items-center justify-center">
          {/* Logo Watermark */}
          <img 
            src="/logo.png" 
            alt="Target Health" 
            className="absolute bottom-6 left-6 w-40 opacity-20"
          />
          <h1 className="text-5xl font-bold text-white z-10">{t.services.title}</h1>
        </div>
      </div>

      {/* Services Section */}
      <section className="py-16 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-800 mb-2">
              {isRTL ? t.services.mainTitle : 'COMPREHENSIVE HEALTHCARE'} <span className="text-cyan-500">{isRTL ? '' : 'SOLUTIONS'}</span>
            </h2>
            <div className="w-24 h-1 bg-orange-500 mx-auto mb-4"></div>
            <p className="text-slate-600 max-w-2xl mx-auto">
              {t.services.subtitle}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, idx) => {
              const iconNames = ['FileText', 'FolderOpen', 'Users', 'BarChart3', 'Settings', 'Laptop', 'Calendar', 'GraduationCap', 'Award'];
              const IconComponent = iconMap[iconNames[idx]];
              return (
                <div 
                  key={service.id}
                  className="bg-white p-8 rounded-lg shadow-md hover:shadow-xl transition-all group"
                >
                  <div className="bg-cyan-500 w-20 h-20 flex items-center justify-center mb-6 group-hover:bg-orange-500 transition-colors">
                    <IconComponent size={36} className="text-white" />
                  </div>
                  <h3 className={`text-2xl font-bold text-slate-800 mb-4 ${isRTL ? 'text-right' : ''}`}>
                    {isRTL && service.titleArabic ? service.titleArabic : service.title}
                  </h3>
                  <p className={`text-slate-600 mb-6 leading-relaxed ${isRTL ? 'text-right' : ''}`}>
                    {isRTL && service.shortDescriptionArabic ? service.shortDescriptionArabic : service.shortDescription}
                  </p>
                  <Link 
                    to={`/services/${serviceSlugMap[idx]}`}
                    className={`inline-flex items-center gap-2 text-orange-500 font-semibold hover:text-orange-600 transition-colors ${isRTL ? 'flex-row-reverse' : ''}`}
                  >
                    {t.services.learnMore}
                    <ArrowRight size={18} />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;